import { Injectable, inject } from '@angular/core';
import { calculatePathScore } from '@functions';
import { BoxDetection } from '@models';
import { MetricsService, SimulationService } from '@services';
import { SceneStore } from '@stores';
import { metrics } from './metrics';

@Injectable({
  providedIn: 'root',
})
export class PrecisionCuttingMetricsService {
  private metricsService = inject(MetricsService);
  private sceneStore = inject(SceneStore);
  private simulationService = inject(SimulationService);

  metrics = metrics;

  trackGrasper(tool: BoxDetection) {
    this.metricsService.trackTool(tool, 'grasper');
  }

  trackScissors(tool: BoxDetection) {
    this.metricsService.trackTool(tool, 'scissors');
  }

  finalizeMetrics() {
    this.metrics.time.value = this.simulationService.recordingTime();
    this.metrics.grasperPath.value = calculatePathScore({
      maxScore: 15,
      minValue: 100,
      maxValue: 300,
      value: this.metricsService.getToolDistance('grasper'),
    });

    this.metrics.scissorsPath.value = calculatePathScore({
      maxScore: 15,
      minValue: 140,
      maxValue: 440,
      value: this.metricsService.getToolDistance('scissors'),
    });

    this.sceneStore.updateMetrics(Object.values(this.metrics));
  }
}
